'use strict';

import CrudTable from './crud-table/crud-table.module';
import Material from './material/material.module';
import FormsComponents from './forms/forms.module';
import Help from './help/help.module';
import PageTimeline from './page-timeline/timeline.module';

const Components = angular
    .module('app.util', [
        CrudTable,
        Material,
        FormsComponents,
        Help,
        PageTimeline
    ])
    .name;

export default Components;



// WEBPACK FOOTER //
// ./src/app/common/core/util/util.module.js